import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	requestAssistanceModalDescription: {
		id: 'request.assistance.modal.description',
		defaultMessage: 'Add a comment to a chosen ticket to receive the FastShift team’s help.',
		description: 'Description for the FastShift assistance modal',
	},
	requestAssistanceModalTitle: {
		id: 'request.assistance.modal.title',
		defaultMessage: 'Request FastShift assistance',
		description: 'Title for the FastShift assistance modal',
	},
	requestAssistanceModalSubtitleNote: {
		id: 'request.assistance.modal.subtitle-note',
		defaultMessage: 'Required fields are marked with an asterisk',
		description:
			'Subtitle note for the FastShift assistance modal, describing that form fields with an asterisk are required',
	},
	requestAssistanceModalDropdownLabel: {
		id: 'request.assistance.modal.dropdown-label',
		defaultMessage: 'Select a MOVE ticket',
		description:
			'Label for the FastShift assistance modal dropdown where users can select a MOVE ticket',
	},
	requestAssistanceModalCommentLabel: {
		id: 'request.assistance.modal.comment-label',
		defaultMessage: 'Add a comment to the ticket',
		description: 'Label for comment field in fastshift assistance modal',
	},
	requestAssistanceModalSendButton: {
		id: 'request.assistance.modal.send-button',
		defaultMessage: 'Send',
		description:
			'Button text for sending the comment to the selected move ticket, on the fastshift assistance modal',
	},
	requestAssistanceModalCancelButton: {
		id: 'request.assistance.modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button text for closing the fastshift assistance modal',
	},
	requestAssistanceModalFailedRequestMessage: {
		id: 'request.assistance.modal.failed-request-error-message',
		defaultMessage: 'An error occurred. Please try again later',
		description:
			'Message shown if there is a server error when trying to create a comment after hitting send',
	},
	requestAssistanceModalFieldIsRequiredMessage: {
		id: 'request.assistance.modal.form-field-required',
		defaultMessage: 'This field is required',
		description: "Error message when user doesn't fill in a required field",
	},
	requestAssistanceModalSuccessFlagTitle: {
		id: 'request.assistance.modal.success-flag-title',
		defaultMessage: 'Comment created',
		description:
			'Title for flag shown when a comment is successfully created on a migration support ticket',
	},
	requestAssistanceModalSuccessFlagDescription: {
		id: 'request.assistance.modal.success-flag-description',
		defaultMessage: 'Comment has been successfully created.',
		description:
			'Description for flag shown when a comment is successfully created on a migration support ticket',
	},
	requestAssistanceModalSuccessFlagAction: {
		id: 'request.assistance.modal.success-flag-action',
		defaultMessage: 'View ticket',
		description:
			'Text for a link that will redirect customer to view their migration support ticket (to which they just posted a comment)',
	},
	requestAssistanceModalErrorFlagTitle: {
		id: 'request.assistance.modal.error-flag-title',
		defaultMessage: 'An error occurred',
		description:
			'Title for flag shown when there is an error creating a comment on a migration support ticket',
	},
	requestAssistanceModalErrorFlagDescription: {
		id: 'request.assistance.modal.success-flag-description',
		defaultMessage: 'Please try again later.',
		description:
			'Description for flag shown when there is an error creating a comment on a migration support ticket',
	},
	requestAssistanceModalEmptyDescription: {
		id: 'request.assistance.modal.empty.description',
		defaultMessage:
			'You don’t have any existing migration support tickets. To request assistance, please create one.',
		description:
			'Description for the FastShift assistance modal when the customer has no open support tickets',
	},
	requestAssistanceModalEmptyModalRaiseTicketButton: {
		id: 'request.assistance.modal.empty.raise-ticket-button',
		defaultMessage: 'Raise ticket',
		description: 'Button to redirect to another website to raise a new support request',
	},
	requestAssistanceModalCancelButtonAriaLabel: {
		id: 'request.assistance.modal.cancel-button-aria-label',
		defaultMessage: 'Cancel request',
		description: 'Aria label for the cancel button in the fastshift assistance modal',
	},
	requestAssistanceModalSendButtonAriaLabel: {
		id: 'request.assistance.modal.send-button-aria-label',
		defaultMessage: 'Send request',
		description: 'Aria label for the send button in the fastshift assistance modal',
	},
	requestAssistanceModalRaiseTicketLinkAriaLabel: {
		id: 'request.assistance.modal.raise-ticket-link-aria-label',
		defaultMessage: 'Raise ticket',
		description: 'Aria label for the raise ticket link in the fastshift assistance modal',
	},
});
